import template from "./live-view.html";
import controller from "./live-view.controller.js";
import "./live-view.scss";

const LiveViewComponent = {
    template,
    controller,
    controllerAs: "ctrl",
    bindings: {
        model: "=",
        config: "<",
        general: "<",
        callback: "&",
        reset: "&",
        isPortraite: "<",
        sharingQr: "<",
        sharingSms: "<",
        sharingEmail: "<",
        sharingPrint: "<",
        showSingle: "<",
        showGif: "<",
        showBoomerang: "<",
        showFilter: "<",
        showScenes: "<",
        isSingle: "<"
    }
};

export default LiveViewComponent;



// WEBPACK FOOTER //
// ./sources/components/configurations/live-view/live-view.component.js